import React, { useState, useEffect } from "react";
import {
  IonCard,
  IonItem,
  IonLabel,
  IonIcon,
  IonCardHeader,
  IonCardTitle,
  IonBadge,
  IonItemDivider,
  IonItemGroup,
} from "@ionic/react";
import { phonePortraitOutline, callOutline, mailOutline } from "ionicons/icons";
import { getRelativeTypes } from "../../../api/server";
import { useIntl } from "react-intl";
import {
  getFullName,
  formatRelativeType,
  getLocalPhoneNumber,
} from "../../../components/util/helpers";
import { parsePhoneNumberFromString } from "libphonenumber-js/max";

const Relatives = (props) => {
  const { activePatient } = props;
  const intl = useIntl();
  const [relatives, setRelatives] = useState(null);

  useEffect(() => {
    async function fetchRelatives() {
      const response = await getRelativeTypes();
      setRelatives(response.data.items);
    }
    fetchRelatives();
  }, []);

  return activePatient.relatives && activePatient.relatives.length > 0 ? (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.relatives",
          })}
        </IonCardTitle>
      </IonCardHeader>
      {activePatient.relatives &&
        activePatient.relatives.map((item) => {
          const relativeType =
            relatives &&
            item.relative_type_id &&
            relatives.filter((i) => i.id === item.relative_type_id)[0].name;
          const parsedPhone =
            item.phone_number && parsePhoneNumberFromString(item.phone_number);
          const parsedMobile =
            item.mobile_number &&
            parsePhoneNumberFromString(item.mobile_number);
          const phone =
            item.phone_number &&
            parsedPhone &&
            parsedPhone.isValid() &&
            getLocalPhoneNumber(item.phone_number);
          const mobile =
            item.mobile_number &&
            parsedMobile &&
            parsedMobile.isValid() &&
            getLocalPhoneNumber(item.mobile_number);
          return (
            <IonItemGroup key={item.id}>
              <IonItemDivider>
                <IonLabel>{`${getFullName(
                  item.last_name,
                  item.first_name
                )} ${formatRelativeType(relativeType)}`}</IonLabel>
              </IonItemDivider>
              {item.mobile_number && (
                <IonItem
                  button
                  onClick={() => {}}
                  lines={item.email || item.mobile_number ? "inset" : "none"}
                  href={`tel:${mobile || item.mobile_number}`}
                >
                  <IonIcon icon={phonePortraitOutline} slot="start" />
                  <IonLabel>{mobile || item.mobile_number}</IonLabel>
                  {item.main_contact && (
                    <IonBadge color="primary" slot="end">
                      {intl.formatMessage({
                        id: "app.mobile.mainRelative",
                      })}
                    </IonBadge>
                  )}
                </IonItem>
              )}
              {item.phone_number && (
                <IonItem
                  button
                  onClick={() => {}}
                  lines={item.email ? "inset" : "none"}
                  href={`tel:${phone || item.phone_number}`}
                >
                  <IonIcon icon={callOutline} slot="start" />
                  <IonLabel>{phone || item.phone_number}</IonLabel>
                  {item.main_contact && (
                    <IonBadge color="primary" slot="end">
                      {intl.formatMessage({
                        id: "app.mobile.mainRelative",
                      })}
                    </IonBadge>
                  )}
                </IonItem>
              )}
              {item.email && (
                <IonItem button onClick={() => {}} lines="none">
                  <IonIcon icon={mailOutline} slot="start" />
                  <IonLabel>{item.email}</IonLabel>
                  {item.main_contact && (
                    <IonBadge color="primary" slot="end">
                      {intl.formatMessage({
                        id: "app.mobile.mainRelative",
                      })}
                    </IonBadge>
                  )}
                </IonItem>
              )}
            </IonItemGroup>
          );
        })}
    </IonCard>
  ) : null;
};

export default Relatives;
